import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { SurveyTextInput } from '../../../../../components/common/survey/inputs/SurveyTextInput';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessBusinessNamePage = () => {
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState<string>();

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  return (
    <JoinProcessPageWrapper
      headerTitle={'사업장 상호명을 알려주세요'}
      canConfirm={businessName !== undefined}
      confirmHandler={() => {
        dispatch(userJoinActions.changeBusinessName(businessName!));
        navigate('/join-process/business-type', { replace: true });
      }}
    >
      <SurveyForm>
        <SurveyInputHeader inputTitle={'상호명 입력'} isRequired />

        <SurveyTextInput
          inputValue={businessName}
          placeholder={'예) 한국 농기계'}
          onChange={(value: string | undefined) => setBusinessName(value)}
        />
      </SurveyForm>
    </JoinProcessPageWrapper>
  );
};
